import { observer } from "mobx-react-lite";
import React from "react";
import { FormControl } from "react-bootstrap";
import { useFormContext } from "./Form";
import { emptyStringIfNull, withFormWrapper, } from "./withFormWrapper";
import { StaticInputValue } from "./StaticInput";
var RawTextArea = observer(function (_a) {
    var name = _a.name, maxLength = _a.maxLength, type = _a.type, rawOnChange = _a.rawOnChange, onChange = _a.onChange, rawOnBlur = _a.rawOnBlur, onBlur = _a.onBlur, disabled = _a.disabled, label = _a.label, staticFormatter = _a.staticFormatter, dataId = _a.dataId, dataLabel = _a.dataLabel, dataTestId = _a.dataTestId, style = _a.style;
    var _b = useFormContext(), values = _b.values, formDisabled = _b.formDisabled, isStatic = _b.isStatic;
    var handleChange = React.useCallback(function (e) {
        if (onChange) {
            onChange(e.target.value, values.get(name));
        }
        if (rawOnChange) {
            rawOnChange(e);
        }
        values.set(name, e.target.value);
    }, [onChange, values, name]);
    var handleBlur = React.useCallback(function (e) {
        if (onBlur) {
            onBlur(e.target.value, values.get(name));
        }
        if (rawOnBlur) {
            rawOnBlur(e);
        }
        values.set(name, e.target.value);
    }, [onBlur, values, name]);
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    return (React.createElement(FormControl, { name: name, type: type, value: emptyStringIfNull(values.get(name)), onChange: handleChange, onBlur: handleBlur, componentClass: "textarea", rows: 5, disabled: disabled || formDisabled, maxLength: maxLength, style: style }));
});
export var TextArea = withFormWrapper({
    WrappedComponent: RawTextArea,
});
